import './singleblog.css';
import {Link} from 'react-router-dom'

const SingleBlog = ({data}) => {
    return (
        <div className='singleblog'>
             <img className='singleblog-img' src={data.img} alt=''/>
           <Link to={`/singleblog/${data.id}`}><h1>{data.title}</h1></Link>
            <p className='desc'>{data.desc}</p>
            <div className='author-details'>
            <img className='author-img' src={data.authorImg} alt=''/>
            <p className='author-name'><b>By:</b> {data.authorName}</p>
            </div>
        
            
        </div>
    );
}

export default SingleBlog;
